<template>
  <div style="width: 100%; height: 100%; background-color: #f9f9f9;overflow-x: hidden;">
    <top-component></top-component>
    <div class="address-wrap">
        <h2>收货地址管理</h2>
        <address-component></address-component>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponentcopy.vue'
  import AddressComponent from '../Components/addressManage.vue'
  export default {
    data() {
      return {
      };
    },
    components: {
      BottomComponent,
      TopComponent,
      AddressComponent
    },
    mounted(){
        let vm = this;
    },
    methods: {
    }
  }
</script>

<style lang="scss">
    .address-wrap{
        width: 1200px;
        margin:20px auto;
        background-color: #fff;
        min-height:500px;
        h2{
            text-align: center;
            font-size:20px;
            padding:20px 0 30px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/addressmanagement.vue